import React, {useEffect, useState} from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { BsEyeFill, BsEyeSlashFill } from 'react-icons/bs'
import './UserPasswordReset.css'

const UserPasswordReset = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();

    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isResetting, setIsResetting] = useState(false);
    const [error, setError] = useState('');
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    useEffect(() => {
        if (!window.sessionStorage.getItem('auth')) {
            navigate('/unauthorized');
        }
    }, [navigate]);

    const handleCancel = () => {
        navigate('/users');
    }

    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (!password.trim()) {
            setError('Password is required');
            return;
        }

        setError('');
        setIsResetting(true);

        try {
            const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/users/user/' + id,
                {
                    method: 'PATCH',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        password: password
                    }),
                });

            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }

            try {
                await response.json();
            }
            catch (jsonError) {
                // Some successful PATCH endpoints return empty bodies.
            }

            setPassword('');
            setShowSuccessDialog(true);
        } catch (requestError) {
            console.error(requestError);
            setError('Failed to reset password. Please try again.');
        } finally {
            setIsResetting(false);
        }
    }

    const displayName = location.state?.userName ? ` for ${location.state.userName}` : '';

    return (
        <div className='user-password-reset-page'>
            <div className='user-password-reset-card'>
                <h2>Reset Password</h2>
                <p className='user-password-reset-subtitle'>Set a new password{displayName}. (User ID: {id})</p>

                <form onSubmit={handleResetPassword}>
                    <label className='user-password-reset-label' htmlFor='reset-password-input'>Password</label>
                    <div className='user-password-input-wrap'>
                        <input
                            id='reset-password-input'
                            className='user-password-reset-input'
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            placeholder='Enter new password'
                            autoComplete='new-password'
                        />
                        <button
                            type='button'
                            className='user-password-visibility-btn'
                            onClick={() => setShowPassword((previous) => !previous)}
                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                        >
                            {showPassword ? <BsEyeSlashFill /> : <BsEyeFill />}
                        </button>
                    </div>

                    {error && <div className='error user-password-reset-error'>{error}</div>}

                    <div className='user-password-reset-actions'>
                        <button type='button' className='btn btn-cancel' onClick={handleCancel} disabled={isResetting}>Cancel</button>
                        <button type='submit' className='btn' disabled={isResetting}>
                            {isResetting ? 'Resetting Password...' : 'Reset Password'}
                        </button>
                    </div>
                </form>
            </div>

            {showSuccessDialog && (
                <div className='modal-container'>
                    <div className='modal-edit user-password-success-modal'>
                        <p className='user-password-success-message'>Password successfully reset.</p>
                        <div className='user-password-success-actions'>
                            <button type='button' className='btn' onClick={() => navigate('/users')}>OK</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default UserPasswordReset
